// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

.popup-content {
  margin: auto;
  background: rgb(255, 255, 255);
  width: 50%;
  padding: 5px;
}
.popup-arrow {
  color: rgb(255, 255, 255);
}
[role='tooltip'].popup-content {
  width: 200px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
}
.popup-overlay {
  background: rgba(0, 0, 0, 0.5);
}
[data-popup='tooltip'].popup-overlay {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\n.popup-content {\n  margin: auto;\n  background: rgb(255, 255, 255);\n  width: 50%;\n  padding: 5px;\n}\n.popup-arrow {\n  color: rgb(255, 255, 255);\n}\n[role='tooltip'].popup-content {\n  width: 200px;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;\n}\n.popup-overlay {\n  background: rgba(0, 0, 0, 0.5);\n}\n[data-popup='tooltip'].popup-overlay {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
